import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "entry", "template", "query", "save", "choice", "results", "frame", "generation"]

  connect() {
    this.sync()
    this.queryTarget.focus()
  }

  disconnect() {
    this.cancelSearch()
  }

  search() {
    this.dismissed = false
    if (!this.queryTarget.value.trim()) this.closeResults()
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submitSearch(), 300)
  }

  submitSearch(event) {
    clearTimeout(this.timeout)
    if (event) this.dismissed = false
    this.queryTarget.form.requestSubmit()
  }

  searchStarted(event) {
    this.submission = event.detail.formSubmission
  }

  cancelSearch() {
    clearTimeout(this.timeout)
    this.submission?.stop()
  }

  renderResults(event) {
    const render = event.detail.render
    event.detail.render = (current, incoming) => {
      if (incoming.dataset.searchGeneration === this.generationTarget.value) return render(current, incoming)
    }
  }

  showResults(event) {
    if (event?.type === "click") this.dismissed = false
    if (!this.queryTarget.value.trim() || this.dismissed || !this.frameTarget.childElementCount) return

    const rect = this.queryTarget.getBoundingClientRect()
    const below = window.innerHeight - rect.bottom - 14
    const above = rect.top - 14
    this.resultsTarget.style.width = `${rect.width}px`
    this.resultsTarget.style.maxHeight = `${Math.min(320, Math.max(above, below))}px`
    this.resultsTarget.showPopover()
    const height = this.resultsTarget.offsetHeight
    this.resultsTarget.style.top = `${below >= height ? rect.bottom + 6 : rect.top - height - 6}px`
    this.resultsTarget.style.left = `${rect.left}px`
    this.queryTarget.setAttribute("aria-expanded", "true")
  }

  closeResults() {
    this.resultsTarget.hidePopover()
    this.queryTarget.setAttribute("aria-expanded", "false")
  }

  dismiss(event) {
    if (event.type !== "keydown" && (this.resultsTarget.contains(event.target) || event.target === this.queryTarget)) return
    this.dismissed = true
    if (!this.resultsTarget.matches(":popover-open")) return

    this.closeResults()
    if (event.type === "keydown") {
      event.preventDefault()
      event.stopPropagation()
      this.queryTarget.focus()
    }
  }

  add(event) {
    const template = event.currentTarget.closest("li").querySelector("template")
    this.append(template.content.firstElementChild.cloneNode(true))
  }

  addTitle() {
    const title = this.queryTarget.value.trim()
    if (!title) return

    const entry = this.templateTarget.content.firstElementChild.cloneNode(true)
    entry.querySelector("input").value = `title:${title}`
    entry.querySelector("[data-title]").textContent = title
    entry.querySelector("[data-title]").parentElement.title = title
    entry.querySelector("button").setAttribute("aria-label", `${entry.querySelector("button").title}: ${title}`)
    this.append(entry)
  }

  append(entry) {
    const choice = entry.querySelector("input").value
    if (this.entryTargets.some(entry => entry.querySelector("input").value === choice)) return

    this.listTarget.append(entry)
    this.cancelSearch()
    this.generationTarget.value = Number(this.generationTarget.value) + 1
    this.frameTarget.replaceChildren()
    this.queryTarget.value = ""
    this.sync()
    this.queryTarget.focus()
  }

  remove(event) {
    event.currentTarget.closest('[data-film-mapping-target="entry"]').remove()
    this.sync()
    this.queryTarget.focus()
  }

  sync() {
    const choices = this.entryTargets.map(entry => entry.querySelector("input").value)
    this.saveTarget.disabled = choices.length === 0
    this.choiceTargets.forEach(row => { row.hidden = choices.includes(row.dataset.choice) })
    if (this.queryTarget.value.trim()) {
      this.showResults()
    } else {
      this.closeResults()
    }
  }
}
